import FileUpload from './FileUpload';
import type FileUploadProps from './FileUpload';

export default FileUpload;
export type { FileUploadProps };
